import { useInfiniteQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useSimulationId } from './useSimulationId';
import { SimulationFilters } from '../modals/SimulationEditModal/components/SimulationFilters';
import { type SimulationSortConfig } from './useSortConfig';

export const simulationLotsQueryKey = (simulationId: string | number) => [
  'simulation-lots-list',
  simulationId.toString(),
];

export const useGetGraphneSimulationLots = (filters: SimulationFilters = {}, sort: SimulationSortConfig = {}) => {
  const api = useGraphneAPI();
  const { id } = useSimulationId();
  const pageSize = 20;

  return useInfiniteQuery({
    queryKey: [...simulationLotsQueryKey(id), JSON.stringify(filters), JSON.stringify(sort)],
    queryFn: ({ pageParam = 0 }) => {
      const finalParams = {
        simulationId: id.toString(),
        page: pageParam,
        pageSize,
        ...filters,
        ...sort,
      };

      return api.getGraphneSimulationSimulationidTasks(finalParams);
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || lastPage.length < pageSize) {
        return undefined;
      }
      return allPages.length;
    },
    initialPageParam: 0,
    select: (data) => data.pages.flat(),
    refetchOnMount: false,
    enabled: !!id,
  });
};
